import React from "react";
import mawgifLogo from "@/assets/img/unnamed_1.png";
import footerLogo1 from "@/assets/img/images.png";
import footerLogo2 from "@/assets/img/ACI_Logo.svg.png";

// Fixed reserved space — canvas hamesha 1280x720 (BASE_WIDTH x BASE_HEIGHT) hai,
// isliye ye pixel values HAR screen pe same rahengi, kabhi shift nahi hongi.
const SIDEBAR_WIDTH = 224; // ~ xl:w-64 ke barabar reserve
const TOP_SPACE = 56; // top-right arrow ke liye reserved height
const BOTTOM_SPACE = 110; // footer logos + page number ke liye reserved height

const PROFILE_PAGE_TYPES = [
  "title_page",
  "last_title",
  "donut_chart_18",
  "donut_chart",
  "jeddah_profile_summary02",
  "jeddah_profile_summary10",
  "jeddah_profile_summary_arabic",
  "sharjha_profile_table",
  "profile_summary_airport_jordan",
  "profile_summary_lovers_market",
  "profile_summary_AlBatha_4",
  "profile_summary_AlBatha_11",
  "profile_summary_dammam",
  "profile_summary_bilal",
  "profile_summary_BabAlRee_4",
  "profile_summary_BabAlRee_11",
  "Gazzaz_4",
  "Gazzaz_11",
  "JedWatch_4",
  "JedWatch_11",
  "total_dubai_airport_profile",
  "dubai_airport_t1_profile",
  "dubai_airport_t2_profile",
  "dubai_airport_t3_profile",
  "dubai_airport_cargo_profile",
  "madinah_haram_profile",
  "madinah_haram_parking_profile",
  "madinah_haram_enforcement_profile",
  "taif_on_street_profile",
  "taif_off_street_profile",
  "khamis_on_street_profile",
  "khamis_off_street_profile",
  "jubail_on_street_profile",
  "alhassa_on_street_profile",
  "mawgif_jeddah_on_street_profile",
  "digital_city_off_street_profile",
  "digital_city_on_street_profile",
  "albaha_on_street_profile",
  "albaha_off_street_profile",
  "dammam_causeway_on_street_profile",
  "dammam_causeway_off_street_profile",
  "baljurashi_on_street_profile",
  "baljurashi_off_street_profile",
  "makkah_on_street_profile",
  "makkah_off_street_profile",
  "makkah_misfalah_profile",
  "makkah_jarwal_profile",
  "jeddah_on_street_profile",
  "jeddah_off_street_profile",
  "moc_on_street_profile",
  "modern_city_contract",
  "capital_parking_on_street_profile"
];

export const BoardPackLayout = ({
  children,
  isSidebar = true,
  isFooter = true,
  isExporting = false,
  page = null,
}) => {
  const isProfilePage = page?.type && PROFILE_PAGE_TYPES.includes(page.type);

  return (
    <>
      {isProfilePage ? (
        <div className="min-h-screen relative mb-5 overflow-hidden  bg-card">
          <div className="origin-top-left">
            <div className="flex min-h-screen relative">
              {/* Left Sidebar  */}
              {isSidebar && (
                <div className="flex w-64 bg-[#006fc0] items-center justify-center absolute left-0 top-0 h-full">
                  <img
                    src={mawgifLogo}
                    alt="Mawgif Logo"
                    className="w-36 object-contain"
                  />
                </div>
              )}

              {/* Top Right L Shape */}
              <div className="absolute top-1 right-2 z-10 pointer-events-none">
                <div className="relative">
                  <div className="w-10 h-3 bg-[#006fc0]" />
                  <div className="absolute top-0 -right-0.5 w-3 h-10 bg-[#006fc0]" />
                </div>
              </div>

              {/* Main Content */}
              <div
                className={`flex-1 relative ${
                  isSidebar ? "ml-64" : "ml-0"
                }`}
              >
                <div className="min-h-screen">
                  <div className="">{children}</div>
                </div>
              </div>

              {/* Page Number */}
              <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 flex gap-4 items-center z-10">
                <span className="text-sm font-medium text-gray-600  px-3 py-0 ">
                  {page?.page_no}
                </span>
              </div>

              {/* Footer Logos */}
              {isFooter && (
                <div className="absolute bottom-1 right-2 flex gap-4 items-center z-10">
                  <img src={footerLogo1} alt="Footer Logo 1" className="h-14 object-contain" />
                  <img src={footerLogo2} alt="Footer Logo 2" className="h-14 object-contain" />
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="relative w-full overflow-hidden bg-card" style={{ height: 720 }}>
          {/* Left Sidebar — fixed, absolute, kabhi content ko touch nahi karega */}
          {isSidebar && (
            <div
              className="absolute left-0 top-0 h-full bg-[#006fc0] flex items-center justify-center"
              style={{ width: SIDEBAR_WIDTH, zIndex: 5 }}
            >
              <img
                src={mawgifLogo}
                alt="Mawgif Logo"
                className="w-36 object-contain"
              />
            </div>
          )}

          {/* Top Right L Shape — fixed position, apna reserved corner */}
          <div className="absolute top-1 right-2 pointer-events-none" style={{ zIndex: 10 }}>
            <div className="relative">
              <div className="w-10 h-3 bg-[#006fc0]" />
              <div className="absolute top-0 -right-0.5 w-3 h-10 bg-[#006fc0]" />
            </div>
          </div>

          {/* Main Content Area — sidebar/top/bottom sab reserved space chhod ke
          jo bacha wahi area hai, aur children uss area ke exact center mein baithenge */}
          <div
            className="absolute flex items-center justify-center"
            style={{
              left: isSidebar ? SIDEBAR_WIDTH : 0,
              right: 0,
              top: TOP_SPACE,
              bottom: BOTTOM_SPACE,
            }}
          >
            <div className={`w-full h-full flex items-center ${page?.type !== "toc_page" && "justify-center"}`}>{children}</div>
          </div>

          {/* Page Number — fixed bottom center */}
          <div
            className="absolute left-1/2 -translate-x-1/2 flex items-center"
            style={{ bottom: 8, zIndex: 10 }}
          >
            <span className="text-sm font-medium text-gray-600 px-3 py-0">{page?.page_no}</span>
          </div>

          {/* Footer Logos — fixed bottom right, reserved space guaranteed by BOTTOM_SPACE */}
          {isFooter && (
            <div
              className="absolute right-2 flex gap-4 items-center"
              style={{ bottom: 8, zIndex: 10 }}
            >
              <img src={footerLogo1} alt="Footer Logo 1" className="h-10 object-contain" />
              <img src={footerLogo2} alt="Footer Logo 2" className="h-10 object-contain" />
            </div>
          )}
        </div>
      )}
    </>
  );
};
